import {
  Column as OriginalColumn,
  ColumnDef as OriginalColumnDef,
} from '@tanstack/react-table';

export enum TableGridLogicOperator {
  And = 'and',
  Or = 'or',
}

export interface ITableSort {
  field: string;
  order: 'asc' | 'desc';
}

export interface ITableQueryResponse<T> {
  data: T[];
}

export interface TableGridFilterItem {
  id: number | string;
  field: string;
  value?: any;
  operator: string;
}

export interface TableGridFilterModel {
  items: TableGridFilterItem[];
  logicOperator?: TableGridLogicOperator;
  quickFilterValues?: any[];
  quickFilterLogicOperator?: TableGridLogicOperator;
  quickFilterExcludeHiddenColumns?: boolean;
}

export interface FilterRow {
  id: string;
  column: string;
  operator: string;
  value: string;
  conjunction: TableGridLogicOperator;
  inputType: TableFilterInputType;
}

export type TableFilterInputType =
  | 'text'
  | 'number'
  | 'boolean'
  | 'date'
  | 'list'
  | 'datetime';
export type TableFilterOperatorType = Array<{ label: string; value: string }>;

export interface TableFilterItem {
  /**
   * The id of the filter
   */
  id?: string;
  /**
   * The field or same cases column accessor key, this will be selected value
   */
  field: string;
  /**
   * The name of the field to display in the filter dropdown
   */
  fieldName: string;
  /**
   * The operators to display in the filter dropdown
   * example: [{ label: 'contains', value: 'contains' }, { label: 'equals', value: 'equals' }]
   */
  operators: TableFilterOperatorType;
  /**
   * The input options to display in the filter dropdown
   * if input options are provided select input will be displayed and input type will be ignored
   * example: [{ label: 'Option 1', value: 'option1' }, { label: 'Option 2', value: 'option2' }]
   */
  inputOptions?: Array<{ label: string; value: string }>;
  /**
   * The type of input to display in the filter dropdown
   * By default, the input type is text
   */
  inputType?: TableFilterInputType;
}

// Extend to add custom properties to the column def
export type IColumnDef<T> = OriginalColumnDef<T> & {
  name?: string;
};

export type IColumn<T> = OriginalColumn<T> & {
  columnDef: IColumnDef<T>;
};
